import { useParams } from "wouter"

import { LogsTable } from "../logs/table"

export function SessionDetailPage() {
  const { id } = useParams<{ id: string }>()

  return <LogsTable key={id} sessionId={id} />
}
